import {
  DeleteWithConfirmButton,
  Toolbar,
  SaveButton,
  useEditController,
  Edit,
  SimpleForm,
} from "react-admin";
import { AnalysisGroupForm } from "./AnalysisGroupForm";
import { formatGroupToSend } from "..";

const EditToolbar = (props) => {
  const { record } = useEditController();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <DeleteWithConfirmButton
        confirmContent="ra.confirm.delete"
        translateOptions={{ name: record.name }}
      />
    </Toolbar>
  );
};

export const AnalysisGroupEdit = () => (
  <Edit transform={formatGroupToSend} redirect="list">
    <SimpleForm
      toolbar={<EditToolbar />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <AnalysisGroupForm />
    </SimpleForm>
  </Edit>
);
